interface PrismMarkProps {
  size?: number;
  className?: string;
}

export function PrismMark({ size = 128, className }: PrismMarkProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      fill="none"
      stroke="currentColor"
      strokeWidth="0.5"
      className={className}
      style={{ filter: "drop-shadow(0 0 20px rgba(99, 102, 241, 0.4))" }}
    >
      <polygon points="50,5 90,25 90,75 50,95 10,75 10,25" />
      <line x1="50" x2="50" y1="5" y2="50" />
      <line x1="90" x2="50" y1="25" y2="50" />
      <line x1="10" x2="50" y1="25" y2="50" />
      <line x1="90" x2="50" y1="75" y2="50" />
      <line x1="10" x2="50" y1="75" y2="50" />
      <line x1="50" x2="50" y1="95" y2="50" />
    </svg>
  );
}
